import { MessageCircle, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "@/lib/api";

export default function FloatingActions() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-white/10 bg-hydro-navy/90 p-3 backdrop-blur-xl md:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href={PHONE_TEL}
        data-testid="floating-call-button"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-hydro-cyan py-3.5 text-sm font-extrabold text-hydro-navy"
      >
        <Phone size={16} strokeWidth={2.5} />
        Sună acum
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 py-3.5 text-sm font-extrabold text-white"
      >
        <MessageCircle size={16} />
        WhatsApp
      </a>
    </div>
  );
}
